function isTouchDevice() {
    return 'ontouchstart' in document.documentElement;
}

jQuery(document).ready(function ($) {

    // Apply style to elements if touch device
    if (isTouchDevice()) {
        $('a, button, input, .sub-menu').addClass('touch-device');
        $('a, button, input, .sub-menu').removeClass('click-device');
    }
    else {
        $('a, button, input, .sub-menu').addClass('click-device');
        $('a, button, input, .sub-menu').removeClass('touch-device');
    }

});